var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.242188,
    width: 30,
    height: 30,
    fill: "url(#pattern0_10933_8472)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_10933_8472",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10933_8472",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10933_8472",
    width: 48,
    height: 48,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAE0ElEQVRoBe1XTWwbRRR+LVWRgIJAwAGJC5WQEBJCRXFKvbtx/lt7x2mhrpCAcEFIPaFIVEICQS78HLj0gKBCTgNUSeoESog9aytqKg6EQ3vkT0gImr+2oU6aNOSnjf2hWWdqZ2Ov14nXOWBL1tuZefPe9733ZvYtUfVXjUA1Av/vCIBoB1Q6CpUMqDQNhZag0i/Q6CQUesIaHRygveaa0MnoTq/tPSpsWfVdHcNLe6ARh0rI+1doGRq9LEFApVcg5grpC1u1dL/Ud1WuRV5EPT/47HwaGvmhUgAqpR3oJ0C001XwwjhUeskBGEnuMhQac6yfkzXXiEClYceAstmQhOyll867BlwahkozrhFQaUb6cU2u3SD2kSw18lJfoQXXgEvDUOhX1zKg0UXpxzUJlT50kcBbrgGXhuGjh6HQVRdI/IkWulf6cVWijlSotFg2EgotQKHnXAVtNY46arZ9u8qDWVymoNJhq/2KjKFQCAqtbjETxysCtpATKNQOlUQUS79aNXq7kN2KzkOl4yWT0OjdioIs5gwKHXF4JkRj11HM3rasQ6MGqDRvU04rohmsKDgYwWdgsI8QC5yGoZ8AP/SIHQAoVAuFpjaQUGgWKrXa7S3rGqKBBxFjJ2HoqzAY7vw5W0CcfYzB4J5CDuGlx6DSaA6J36HRU4X0yzoP0A5wvR0Gm74DOpeAfOb6JAz2Bi74duUDgEN0NzQ6BZXOwEf35dMp+xzi+j5wNmoLXBKQMsZ+gxEMlR3MZgzC0FMlgZckMnIEiUBl2wEryS2Az5wRztIwWAT88F6rbesYnb5dE6drnr361YFHrWubHm+ZgMwIZ7dgsFP5bixxxibCnvbxcM3keNiD8S9qFq90e99L9vh6k71aNNlT/+L2E5BEDDYDg3UgErpLgJrs2r9vPOz50QQuwIdrce1rBcneOiR7feb/5kBzOhXT/wBnl81bMBLa7ZiQ0wzcGvIjzfXs1ZoFvH5u+BhgBJHi/s/Gujyfj4U9KRN8lwdXvvTieg7wuf4G3B7yr98v7HL2SdkJCKJL51qx9F3rRoeSzMhrwKVOYLQDKa6nJ7pqIcBPdu/HPz3ZiM/01WN58CBgFAgI16+7QkCQWBk8iBuRBqx8LwDkvOziQeDiOxkCgkTiCKa6n8e1M6JcMqUi5L/ftjjIZHDcNQICtEj7bF895vsbxXPmrZ14Abj0fobATyewGvUj2ZMFPtffiNVoYD3p3ADIZ3GrxfXXN0sgBiPYj8zVaOssxXXMRRrN6M73N2XAifofeRUp3gZR3yLis2frN2ZLgt0o/4YRDDoGLxTNMuBsCnF2TG5ErK0WcfbDuhLZ6AxpznBzoMkEOtPnw/xAk5kVWTKL50S55JRZHhtrPpbB2QcYYvdIDI4lDPYphkMP5NuABNPB9Z+LEREHWxAQwG+crcfCN81YjTkolwyhBGL+J/P5L8scOjt3ir4HPPCXHRFxxd6O+pFyClw0hlxvLwtIJ0YQCe1GPPgm4vqsHZGia+KNLVp2m9bcCZ5N6yDe+pD5bcDZUlGw1prn7ALi7OlNOy/nRiTaHjd7H+vHjxW0GFe6XEohKiIKrg/lzcZ2l0tJRDhrgaGfh6GvQHyCihY7GqjMJ2UpQKu61QhUI7B9EfgPi4J/ZkzIPoQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustSecurity);
export default __webpack_public_path__ + "static/media/trust-security.fef663006790bf40b1ab44b6cf285b06.svg";
export { ForwardRef as ReactComponent };